import { Text } from "@imminently/react/ui/core/text";
import { GridColDef } from "@mui/x-data-grid";
import { startCase } from "lodash";

import PatientHistoryDataGrid from "@/components/Patient/PatientHistoryDataGrid";
import { HEALTH_HIST_LABELS } from "./PatientInfoTabConsts";

type MedicalHistoryRow = {
  id: string;
  type?: string;
  details?: string;
};



const DetailsCell = ({ details }: { details: string }) => {
  const detailItems = details.split(", ").map(startCase);

  if (detailItems.length === 0) {
    return null;
  } else if (detailItems.length === 1) {
    return <Text>{startCase(detailItems[0])}</Text>;
  }

  return (
    <div style={{ margin: 0, padding: 0 }}>
      {detailItems.map((detail, index) => (
        <div key={index} style={{ margin: 0, padding: 0 }}>
          <Text>{startCase(detail)}</Text>
        </div>
      ))}
    </div>
  );
};

const gridColumns: GridColDef[] = [
  {
    field: "type",
    headerName: "System",
    flex: 1,
    valueFormatter: (value: any) => value ? ((HEALTH_HIST_LABELS as any)[value] ?? startCase(value)) : "",
  },
  {
    field: "details",
    headerName: "Details",
    flex: 2,
    renderCell: ({ value }) => <DetailsCell details={value} />,
  },
];

const PatientMedicalHistory = ({ rows }: { rows: MedicalHistoryRow[] }) => {
  return (
    <PatientHistoryDataGrid
      rows={rows}
      columns={gridColumns}
      getRowHeight={() => "auto"}
    />
  );
};

export default PatientMedicalHistory;
